import React from 'react'
import { AiOutlineCloseCircle, AiOutlineUserDelete } from 'react-icons/ai'
import { BsTrash2 } from 'react-icons/bs'

const AccountConfirmModal = ({
  onClose,
  onConfirm,
}) => {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[99999] backdrop-blur-md">
      <div className="bg-white dark:bg-dark rounded-lg shadow-lg w-full max-w-[400px] p-4 relative overflow-hidden">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300"
        >
          <AiOutlineCloseCircle className="h-7 w-7 text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300" />
        </button>

        <div className="flex flex-col items-center text-center">
          <div className="w-16 h-16 bg-yellow-main/10 rounded-full flex items-center justify-center mb-3">
            <div className="w-12 h-12 bg-red-500/30 rounded-full flex items-center justify-center">
              <AiOutlineUserDelete className="h-8 w-8 text-red-500" />
            </div>
          </div>

          <h2 className="text-xl font-bold mb-2 dark:text-white">
            Delete Account
          </h2>
          <p className="text-gray-600 text-sm dark:text-gray-400 mb-6">
            Are you sure you want to delete your account? This action is irreversible.
          </p>

          <div className="flex gap-4 w-full">
            <button className="flex-1 h-12 rounded-full border border-gray-400 dark:border-border-darkGray dark:text-white" onClick={onClose}>
              Cancel
            </button>
            <button className="flex-1 h-12 rounded-full bg-red-500 hover:bg-red-600 text-white" onClick={onConfirm}>
              Delete Account
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AccountConfirmModal